define('MachineLookUp.Model',
  [
    'SCModel',
    'Utils'
  ],
  function
  (
    SCModelModule,
    Utils
  ) {
    'use strict';

    var SCModel = SCModelModule.SCModel;

    function MachineLookUpModel(model, options) {
      SCModel.call(this, model, options);

      this.urlRoot = function urlRoot() {
        return Utils.getAbsoluteUrl(getExtensionAssetsPath('services/MachineLookUp.Service.ss'))
      };
    }

    MachineLookUpModel.prototype = Object.create(SCModel.prototype);
    MachineLookUpModel.prototype.constructor = MachineLookUpModel;

    return MachineLookUpModel;
  });
